import http from '@/service'
import config from '@/config';
import {
  log
} from '@/logging';

export default {
  async getBillingAccounts(sessionId) {
    const headers = { 
      sessionId: sessionId
    };
    log.debug('Getting billing account information');
    try {
      const response = await http.get(config.endpoints.billingAccounts, { headers });
      log.debug('Billing account information obtained: [data="', response.data, '"]');
      if (response.data.code === "OK" && response.data.data !== undefined && response.data.success) {
        return response;
      } 
    } catch (Error) {

    }
  }
}
